import React from 'react'

import { Card, CardContent, CardHeader } from '@mui/material'
import { useParams } from 'react-router-dom'

import { EditDetailsForm } from 'components/campaign-edit'
import LoadingView from 'components/LoadingView'
import useCampaign, { useUpdateCampaign } from 'hooks/useCampaign'

const CampaignEdit = () => {
  const { id } = useParams()
  const { data, isLoading, error } = useCampaign(id)
  const updateCampaign = useUpdateCampaign()

  const handleSubmit = (values: any) => updateCampaign.mutate({ id, values })

  const initialValues = data && {
    ...data.details,
    region: data.adExchangeDetails.region,
    customer: {
      id: data.details.customerId,
      name: data.details.customerName,
    },
  }

  return (
    <Card>
      <CardHeader title="Campaign Edit" />
      <CardContent>
        <LoadingView error={error ? 'Error occurred when loading campaign data' : undefined} loading={isLoading}>
          {data && (
            <EditDetailsForm initialValues={initialValues} loading={updateCampaign.isPending} onSubmit={handleSubmit} />
          )}
        </LoadingView>
      </CardContent>
    </Card>
  )
}

export default CampaignEdit
